<template>
  <v-dialog v-model="show" persistent>
    <div class="text-center">
      <v-progress-circular
        :size="100"
        :width="10"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: ["showProgress"],
  computed: {
    show() {
      return this.showProgress;
    },
  },
};
</script>
